export default __webpack_public_path__ + "static/media/AnimacijaConversation_about_fou_ding_a_company_EN.0cd858f5.mp4";